'use es6';

export const PQL_KEYS = {
  DATE_RANGE: 'revenue-attribution-card-change-date-range',
  OPEN_BUILDER: 'revenue-attribution-card-open-builder',
  TOGGLE_MODEL: 'revenue-attribution-card-toggle-model',
  SAVE_AS_REPORT: 'revenue-attribution-card-save-as-report'
};